<template>
  <div
    class="quote quote1 quote--1 lp-section width-expand padding-xl-vertical"
    :class="`bg-${backgroundColor}`"
    :id="`Quote1-${pageUid}`">
    <div
      class="container container-s padding-xl-vertical gap-l flex-break-column-center">
      <div
        class="width-expand flex flex-column m:flex-row flex-middle flex-center gap-xl">
        <div class="media-side">
          <img class="max-size-parent" v-bind="image" :src="image.finalSrc" />
        </div>
        <div class="content-side width-expand">
          <div style="max-height: var(--margin-s)">
            <span
              class="c-gray-4 margin-remove"
              style="
                line-height: 0.1;
                font-size: calc(var(--font-max) * 1.85);
                max-height: var(--margin-m);
              "
              >"</span
            >
          </div>
          <p class="text-l margin-l-bottom" :class="`c-${textColor}`">
            {{ text }}
          </p>
          <strong :class="`c-${bottomTextColor}`">{{ bottomText }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      image: {},
      text: "",
      bottomText: "",

      backgroundColor: "",
      textColor: "",
      bottomTextColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    async testMethod() {
      console.log("doing test!", this.trackEvent);
      await utilities.wait(1000);
      console.log("all done with test method");
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.quote1 {
  .media-side {
    max-width: calc(var(--base-margin) * 180);
    max-height: calc(var(--base-margin) * 180);

    img {
      max-width: calc(var(--base-margin) * 180);
      max-height: calc(var(--base-margin) * 180);
      object-fit: contain;
    }
  }
}
</style>
